import styled from 'styled-components';

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 58px;
  // padding: 12px;

  img {
    max-width: 140px;
    max-height: 40px;
    object-fit: contain;
  }
`;